/* ZIVBAY Nova 1.0.0 - vanilla JS, no dependencies */
(function () {
  'use strict';
  var ZB = window.ZB || { routes: {}, strings: {}, settings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function announce(msg) { var r = $('#ZBLiveRegion'); if (r) { r.textContent = ''; setTimeout(function () { r.textContent = msg; }, 50); } }
  var toastTimer;
  function toast(msg) {
    var t = $('#ZBToast'); if (!t) return;
    t.textContent = msg; t.hidden = false; announce(msg);
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2800);
  }
  function lockScroll(on) { document.body.classList.toggle('lock-scroll', !!on); }
  function rootUrl(path) { return (ZB.routes.root || '/').replace(/\/$/, '') + '/' + path.replace(/^\//, ''); }
  function parseSection(html, id) {
    var d = document.createElement('div'); d.innerHTML = html;
    return d.querySelector('#shopify-section-' + id) || d;
  }

  /* ---------- Focus-managed layers (drawers, modals, overlays) ---------- */
  var layerStack = [];
  function openLayer(el, opts) {
    opts = opts || {};
    var layer = { el: el, prev: document.activeElement, close: opts.close };
    layerStack.push(layer); lockScroll(true);
    setTimeout(function () {
      var f = (opts.focus && $(opts.focus, el)) || $(FOCUSABLE, el);
      if (f) f.focus();
    }, 30);
    return layer;
  }
  function closeLayer(el) {
    var i = layerStack.map(function (l) { return l.el; }).indexOf(el); if (i < 0) return;
    var l = layerStack.splice(i, 1)[0];
    if (!layerStack.length) lockScroll(false);
    if (l.prev && l.prev.focus) { try { l.prev.focus(); } catch (e) {} }
  }
  document.addEventListener('keydown', function (e) {
    var top = layerStack[layerStack.length - 1]; if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); if (top.close) top.close(); return; }
    if (e.key === 'Tab') {
      var items = $$(FOCUSABLE, top.el).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Drawers ---------- */
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]'); if (!d || d.classList.contains('is-open')) return;
    d.classList.add('is-open');
    openLayer(d, { close: function () { closeDrawer(name); } });
  }
  function closeDrawer(name) {
    var d = $('[data-drawer="' + name + '"]'); if (!d) return;
    d.classList.remove('is-open'); closeLayer(d);
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return; }
    var c = e.target.closest('[data-close-drawer]');
    if (c) { var d = c.closest('[data-drawer]'); if (d) closeDrawer(d.getAttribute('data-drawer')); }
  });

  /* ---------- Search overlay + predictive search ---------- */
  function openSearch() {
    var ov = $('#ZBSearchOverlay'); if (!ov) return;
    ov.classList.add('is-open'); ov.setAttribute('aria-hidden', 'false');
    openLayer(ov, { focus: 'input[type=search]', close: closeSearch });
  }
  function closeSearch() {
    var ov = $('#ZBSearchOverlay'); if (!ov) return;
    ov.classList.remove('is-open'); ov.setAttribute('aria-hidden', 'true'); closeLayer(ov);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-close-search]')) closeSearch();
  });

  function initPredictive(form) {
    var input = $('input[type=search]', form), panel = $('.predictive', form), clear = $('.search-form__clear', form);
    if (!input) return;
    var ctrl, idx = -1;
    function hide() { if (panel) { panel.hidden = true; panel.innerHTML = ''; } input.setAttribute('aria-expanded', 'false'); idx = -1; }
    function items() { return panel ? $$('.predictive__item,.predictive__all', panel) : []; }
    function select(i) {
      var its = items(); if (!its.length) return;
      idx = (i + its.length) % its.length;
      its.forEach(function (n, k) { n.setAttribute('aria-selected', k === idx ? 'true' : 'false'); });
      its[idx].scrollIntoView({ block: 'nearest' });
    }
    var run = debounce(function () {
      var q = input.value.trim();
      if (clear) clear.hidden = !input.value;
      if (!panel) return;
      if (q.length < 2) { hide(); return; }
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      panel.hidden = false; panel.innerHTML = '<div class="predictive__loading">' + ZB.strings.loading + '</div>';
      input.setAttribute('aria-expanded', 'true');
      var url = ZB.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { panel.innerHTML = parseSection(html, 'predictive-search').innerHTML; idx = -1; announce($$('.predictive__item', panel).length + ' ' + ZB.strings.resultsAnnounce); })
        .catch(function (err) { if (err.name !== 'AbortError') hide(); });
    }, 250);
    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) {
      if (!panel || panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); select(idx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); select(idx - 1); }
      else if (e.key === 'Enter' && idx >= 0) { e.preventDefault(); items()[idx].click(); }
      else if (e.key === 'Escape') { hide(); }
    });
    if (clear) clear.addEventListener('click', function () { setTimeout(function () { clear.hidden = true; hide(); input.focus(); }, 0); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    if (clear) clear.hidden = !input.value;
  }
  $$('[data-search-form]').forEach(function (f) { if (f.hasAttribute('data-predictive')) initPredictive(f); else { var i = $('input[type=search]', f), c = $('.search-form__clear', f); if (i && c) { i.addEventListener('input', function () { c.hidden = !i.value; }); c.hidden = !i.value; } } });

  /* ---------- Header: sticky shadow, mega menu, announcement ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  $$('[data-mega]').forEach(function (item) {
    var trigger = $('[data-mega-trigger]', item), timer, touch = window.matchMedia('(hover: none)').matches;
    function open() { clearTimeout(timer); $$('[data-mega].is-open').forEach(function (o) { if (o !== item) setOpen(o, false); }); setOpen(item, true); }
    function setOpen(el, v) { el.classList.toggle('is-open', v); var t = $('[data-mega-trigger]', el); if (t) t.setAttribute('aria-expanded', v ? 'true' : 'false'); }
    function close() { timer = setTimeout(function () { setOpen(item, false); }, 120); }
    item.addEventListener('mouseenter', function () { if (!touch) open(); });
    item.addEventListener('mouseleave', function () { if (!touch) close(); });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { setOpen(item, false); if (trigger) trigger.focus(); }
      if (e.key === 'ArrowDown' && document.activeElement === trigger) { e.preventDefault(); open(); var f = $('.mega a', item); if (f) f.focus(); }
    });
    if (trigger) trigger.addEventListener('click', function (e) { if (touch && !item.classList.contains('is-open')) { e.preventDefault(); open(); } });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-mega]')) $$('[data-mega].is-open').forEach(function (o) { o.classList.remove('is-open'); }); });

  (function () {
    var items = $$('[data-announcement] .announcement__item'); if (items.length < 2 || reduceMotion) return;
    var i = 0; setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4500);
  })();

  /* ---------- Quantity controls ---------- */
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-qty-plus]'), minus = e.target.closest('[data-qty-minus]');
    if (!plus && !minus) return;
    var wrap = (plus || minus).closest('.qty'), input = $('input', wrap); if (!input) return;
    var v = parseInt(input.value, 10) || 0, min = input.hasAttribute('data-line-qty') ? 0 : 1;
    v = plus ? v + 1 : Math.max(min, v - 1); input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  function applyCart(html) {
    var doc = parseSection(html, 'cart-render');
    var items = $('[data-r="items"]', doc), total = $('[data-r="total"]', doc), count = $('[data-r="count"]', doc), footer = $('[data-r="footer"]', doc);
    var n = count ? parseInt(count.textContent, 10) || 0 : 0;
    var ci = $('#CartItems'); if (ci && items) ci.innerHTML = items.innerHTML;
    $$('[data-cart-total]').forEach(function (t) { if (total) t.textContent = total.textContent; });
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
    $$('[data-cart-count-text]').forEach(function (c) { c.textContent = '(' + n + ')'; });
    $$('#CartFooter,[data-cart-footer]').forEach(function (f) { f.hidden = !(footer && footer.textContent.trim()); });
  }
  function refreshCart() {
    return fetch(ZB.routes.cart + '?section_id=cart-render').then(function (r) { return r.text(); }).then(applyCart);
  }
  function changeLine(line, qty) {
    var ci = $('#CartItems'); if (ci) ci.style.opacity = '.5';
    return fetch(ZB.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.status && j.description) toast(j.description); return refreshCart(); })
      .catch(function () { toast(ZB.strings.error); })
      .then(function () { if (ci) ci.style.opacity = ''; });
  }
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-line-qty]'); if (inp) changeLine(parseInt(inp.getAttribute('data-line-qty'), 10), Math.max(0, parseInt(inp.value, 10) || 0));
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove-line]'); if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]'); if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = $('[type=submit]', form) || $('[data-atc]', form), errEl = $('[data-form-error]', form);
    if (btn && btn.disabled) return;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (errEl) errEl.hidden = true;
    fetch(ZB.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) { var msg = j.description || j.message || ZB.strings.error; if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else toast(msg); return; }
        var qv = $('#ZBQuickView'); if (qv && !qv.hidden) closeQuickView();
        return refreshCart().then(function () {
          if (ZB.settings.cartType === 'drawer' && $('[data-drawer="cart"]')) openDrawer('cart'); else toast(ZB.strings.added);
          announce(ZB.strings.added);
        });
      })
      .catch(function () { toast(ZB.strings.error); })
      .then(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
  });

  /* ---------- Wishlist (localStorage, per browser) ---------- */
  var WL = 'zb_wishlist';
  function store(key) {
    return {
      get: function () { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } },
      set: function (v) { try { localStorage.setItem(key, JSON.stringify(v)); } catch (e) {} }
    };
  }
  var wl = store(WL), rv = store('zb_recent');
  function syncWishlist(root) {
    var list = wl.get();
    $$('[data-wishlist-toggle]', root).forEach(function (b) { var on = list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1; b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wishlist-toggle'), list = wl.get(), i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast(ZB.strings.wishlistRemoved); } else { list.unshift(h); toast(ZB.strings.wishlistAdded); }
    wl.set(list); syncWishlist(document);
    var page = b.closest('[data-wishlist-page]');
    if (page && i > -1) { var card = b.closest('.card'); if (card) card.remove(); if (!$('.card', page)) $('[data-wishlist-empty]', page).hidden = false; }
  });
  function fetchCards(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch(rootUrl('products/' + h) + '?section_id=card-render').then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { var c = t ? $('article.card', parseSection(t, 'card-render')) : null; return c ? c.outerHTML : ''; }).catch(function () { return ''; });
    }));
  }
  var wpage = $('[data-wishlist-page]');
  if (wpage) {
    var hs = wl.get(), grid = $('[data-wishlist-grid]', wpage);
    if (!hs.length) $('[data-wishlist-empty]', wpage).hidden = false;
    else fetchCards(hs).then(function (cards) { grid.innerHTML = cards.join(''); syncWishlist(wpage); if (!cards.join('')) $('[data-wishlist-empty]', wpage).hidden = false; });
  }

  /* ---------- Recently viewed ---------- */
  var pdp = $('[data-pdp]');
  if (pdp) { var cur = pdp.getAttribute('data-product-handle'), r = rv.get().filter(function (h) { return h !== cur; }); r.unshift(cur); rv.set(r.slice(0, 12)); }
  $$('[data-recently-viewed]').forEach(function (sec) {
    var cur = sec.getAttribute('data-current'), lim = parseInt(sec.getAttribute('data-limit'), 10) || 4;
    var hs = rv.get().filter(function (h) { return h !== cur; }).slice(0, lim); if (!hs.length) return;
    fetchCards(hs).then(function (cards) { var html = cards.join(''); if (!html) return; $('[data-rv-grid]', sec).innerHTML = html; sec.hidden = false; syncWishlist(sec); });
  });

  /* ---------- Quick view ---------- */
  var qvEl = $('#ZBQuickView');
  function closeQuickView() { if (!qvEl) return; qvEl.hidden = true; closeLayer(qvEl); }
  function openQuickView(handle) {
    if (!qvEl) return;
    var content = $('[data-content]', qvEl); content.innerHTML = '<div class="modal__loading">' + ZB.strings.loading + '</div>';
    qvEl.hidden = false; openLayer(qvEl, { close: closeQuickView });
    fetch(rootUrl('products/' + handle) + '?section_id=quick-view').then(function (r) { return r.text(); })
      .then(function (t) { content.innerHTML = parseSection(t, 'quick-view').innerHTML; var f = $(FOCUSABLE, content); if (f) f.focus(); })
      .catch(function () { content.innerHTML = '<p>' + ZB.strings.error + '</p>'; });
    qvHandle = handle;
  }
  var qvHandle;
  if (qvEl) {
    qvEl.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeQuickView(); });
    qvEl.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-qv-select]'); if (!sel) return;
      $('[data-variant-id]', qvEl).value = sel.value;
      fetch(rootUrl('products/' + qvHandle) + '?variant=' + sel.value + '&section_id=quick-view').then(function (r) { return r.text(); })
        .then(function (t) { var n = $('[data-swap="qv-price"]', parseSection(t, 'quick-view')), o = $('[data-swap="qv-price"]', qvEl); if (n && o) o.innerHTML = n.innerHTML; });
    });
  }
  document.addEventListener('click', function (e) { var q = e.target.closest('[data-quick-view]'); if (q) { e.preventDefault(); openQuickView(q.getAttribute('data-quick-view')); } });

  /* ---------- Product page ---------- */
  if (pdp) {
    var sid = pdp.getAttribute('data-section-id'), purl = pdp.getAttribute('data-product-url');
    var variants = []; try { variants = JSON.parse($('[data-variants]', pdp).textContent); } catch (e) {}
    var main = $('[data-gallery-main]', pdp), thumbs = $$('[data-thumb]', pdp), slides = $$('.gallery__slide', pdp);
    function goTo(id) {
      var s = slides.filter(function (x) { return x.getAttribute('data-media-id') === String(id); })[0]; if (!s || !main) return;
      if (document.dir !== 'rtl') main.scrollTo({ left: s.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      else s.scrollIntoView({ inline: 'start', block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.getAttribute('data-thumb')); }); });
    if (main && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { var id = en.target.getAttribute('data-media-id'); thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === id ? 'true' : 'false'); }); } });
      }, { root: main, threshold: .6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    // Zoom lightbox
    pdp.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom]'); if (!z) return;
      var src = z.getAttribute('data-zoom-src'), box = document.createElement('div');
      box.className = 'modal'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
      box.innerHTML = '<div class="modal__backdrop"></div><div class="modal__panel" style="background:#fff;width:min(1100px,100%)"><button class="modal__close icon-btn" aria-label="Close">&times;</button><img src="' + src + '" alt="" style="width:100%;max-height:88vh;object-fit:contain"></div>';
      document.body.appendChild(box);
      function close() { box.remove(); closeLayer(box); }
      box.addEventListener('click', function (ev) { if (ev.target.closest('.modal__backdrop,.modal__close')) close(); });
      openLayer(box, { close: close });
    });
    // Variants
    var form = $('form.pdp__form', pdp) || $('form[data-ajax-add]', pdp);
    function selected() { return $$('fieldset[data-option]', pdp).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; }); }
    function findVariant(opts) { return variants.filter(function (v) { return opts.every(function (o, i) { return v.options[i] === o; }); })[0]; }
    function markAvailability() {
      var sel = selected();
      $$('fieldset[data-option]', pdp).forEach(function (fs, pos) {
        $$('input[data-option-input]', fs).forEach(function (inp) {
          var test = sel.slice(); test[pos] = inp.value;
          var v = findVariant(test); inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function swap(html) {
      var doc = parseSection(html, sid);
      $$('[data-swap]', pdp).forEach(function (el) { var n = $('[data-swap="' + el.getAttribute('data-swap') + '"]', doc); if (n) el.innerHTML = n.innerHTML; });
    }
    if (form && variants.length > 1) {
      markAvailability();
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-input]')) return;
        var lab = $('[data-option-label]', e.target.closest('fieldset')); if (lab) lab.textContent = e.target.value;
        var v = findVariant(selected()); markAvailability();
        var buy = $('[data-atc]', pdp);
        if (!v) { if (buy) { buy.disabled = true; } toast(ZB.strings.error); return; }
        $('[data-variant-id]', form).value = v.id;
        if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
        if (v.featured_media) goTo(v.featured_media.id);
        fetch(purl + '?variant=' + v.id + '&section_id=' + sid).then(function (r) { return r.text(); }).then(swap).then(function () { announce(''); });
      });
    }
    // Sticky ATC
    var sticky = $('[data-sticky-atc]', pdp), atc = $('[data-atc]', pdp);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var en = es[0], show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(atc);
    }
  }

  /* ---------- Collection filters ---------- */
  $$('[data-auto-submit]').forEach(function (el) { el.addEventListener('change', function () { var f = el.closest('form'); if (f) f.submit(); }); });
  var fpanel = $('#ZBFilters'), backdrop;
  function toggleFilters() {
    if (!fpanel) return;
    var open = !fpanel.classList.contains('is-open');
    fpanel.classList.toggle('is-open', open);
    if (open) { backdrop = document.createElement('div'); backdrop.className = 'filters-backdrop'; backdrop.addEventListener('click', toggleFilters); document.body.appendChild(backdrop); openLayer(fpanel, { close: toggleFilters }); }
    else { if (backdrop) backdrop.remove(); closeLayer(fpanel); }
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-toggle-filters]')) { e.preventDefault(); toggleFilters(); } });

  /* ---------- Hero slider ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var track = $('[data-hero-slides]', hero), dots = $$('[data-hero-dot]', hero); if (!track) return;
    function go(d) { var w = track.clientWidth, rtl = document.dir === 'rtl'; track.scrollBy({ left: (rtl ? -d : d) * w, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    var p = $('[data-hero-prev]', hero), n = $('[data-hero-next]', hero);
    if (p) p.addEventListener('click', function () { go(-1); }); if (n) n.addEventListener('click', function () { go(1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { track.scrollTo({ left: Math.abs(i) * track.clientWidth * (document.dir === 'rtl' ? -1 : 1), behavior: reduceMotion ? 'auto' : 'smooth' }); }); });
    track.addEventListener('scroll', debounce(function () { var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth); dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }, 60), { passive: true });
  });

  syncWishlist(document);
  window.addEventListener('pageshow', function () { syncWishlist(document); });
})();
